// removed by extract-text-webpack-plugin
module.exports = {"sec":"BindFriends__sec__27bDXzkz","btn_left":"BindFriends__btn_left__M9B8HZoa","btn_right":"BindFriends__btn_right__2E1W4bo8","content":"BindFriends__content__3G1kJDTO","cur":"BindFriends__cur__2gQufHC4","nocur":"BindFriends__nocur__1akShG62","totalticket":"BindFriends__totalticket__33ywaD8a","friend_pic":"BindFriends__friend_pic__3SYOE0hZ","pic_mask":"BindFriends__pic_mask__1xAXazrN","btn_send":"BindFriends__btn_send__3XMtYS5R","btn_changebind":"BindFriends__btn_changebind__3HTf0gnp","add_pic":"BindFriends__add_pic__2071F1nb"};


//////////////////
// WEBPACK FOOTER
// ./src/components/BindFriends/BindFriends.scss
// module id = g/92
// module chunks = 0